import { cn } from "../lib/utils";

export function Card({ className, children, ...props }) {
  return (
    <div className={cn("rounded-2xl border border-slate-200 bg-white shadow-sm", className)} {...props}>
      {children}
    </div>
  );
}

export function CardHead({ title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between gap-3 px-5 pt-5">
      <div>
        <h2 className="text-lg font-semibold tracking-tight text-slate-900 font-head">{title}</h2>
        {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Btn({ className, variant = "primary", children, ...props }) {
  const styles = {
    primary: "bg-primary text-primary-foreground hover:bg-neutral-800 shadow-sm",
    outline: "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-300",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "bg-rose-600 text-white hover:bg-rose-700",
  };
  return (
    <button
      className={cn("inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors disabled:opacity-50", styles[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
}

export function IconBtn({ className, children, title, ...props }) {
  return (
    <button title={title} className={cn("inline-grid place-items-center h-8 w-8 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-900 transition-colors", className)} {...props}>
      {children}
    </button>
  );
}

const inputCls = "w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors";

export function Label({ children }) {
  return <label className="block text-xs font-semibold text-slate-600 mb-1.5 mt-3">{children}</label>;
}
export function TextInput(props) { return <input type="text" className={inputCls} {...props} />; }
export function NumberInput(props) { return <input type="number" className={cn(inputCls, "tnum")} {...props} />; }
export function DateInput(props) { return <input type="date" className={inputCls} {...props} />; }
export function TextArea(props) { return <textarea className={inputCls} {...props} />; }
export function NativeSelect({ children, ...props }) {
  return <select className={cn(inputCls, "appearance-none bg-no-repeat pr-9")} style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")", backgroundPosition: "right 0.75rem center" }} {...props}>{children}</select>;
}

export function StatCard({ label, value, sub, tone = "default", testid }) {
  const toneCls = {
    default: "text-slate-900",
    income: "text-emerald-600",
    expense: "text-rose-600",
    pos: "text-emerald-600",
    neg: "text-rose-600",
    brand: "text-amber-600",
  }[tone];
  return (
    <Card className="p-5" data-testid={testid}>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
      <p className={cn("mt-2 text-2xl sm:text-3xl font-extrabold tracking-tight tnum font-head", toneCls)}>{value}</p>
      {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </Card>
  );
}

export function Pill({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700",
    income: "bg-emerald-50 text-emerald-700",
    expense: "bg-rose-50 text-rose-700",
    brand: "bg-amber-50 text-amber-700",
  };
  return <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", tones[tone])}>{children}</span>;
}

export function EmptyState({ children }) {
  return <div className="text-center text-sm text-muted-foreground py-12">{children}</div>;
}

export function TableWrap({ children }) {
  return <div className="overflow-x-auto"><table className="w-full text-sm">{children}</table></div>;
}
export function Th({ children, className }) {
  return <th className={cn("text-left font-semibold text-xs uppercase tracking-wider text-slate-400 px-4 py-3 border-b border-slate-200 whitespace-nowrap", className)}>{children}</th>;
}
export function Td({ children, className }) {
  return <td className={cn("px-4 py-3 border-b border-slate-100 text-slate-700 align-middle", className)}>{children}</td>;
}
